var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HttpClient } from "@angular/common/http";
import { IpsBaseWebService, ActiveProfileService } from "imagine-ui-ng-core";
import { environment } from "../../../environments/environment";
var FixtureGroupService = /** @class */ (function (_super) {
    __extends(FixtureGroupService, _super);
    function FixtureGroupService(http, activeProfileService) {
        var _this = _super.call(this, http, environment, activeProfileService) || this;
        _this.init("FixtureType", "Profile", "v1");
        return _this;
    }
    FixtureGroupService.prototype.simpleSearch = function (searchParams) {
        return this.search(searchParams, "FixtureType/SimpleSearch");
    };
    FixtureGroupService.prototype.deleteCheck = function (id) {
        var route = "" + this.urlApiBasePlusController + id + "/DeleteCheck";
        return this.getByRoute(route);
    };
    return FixtureGroupService;
}(IpsBaseWebService));
export { FixtureGroupService };
